import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'PricingMode';
const ENDPOINT = `/pricing-modes/`;

@Injectable({
    providedIn: 'root'
})
export class PricingModeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
